import { Component, OnInit } from '@angular/core';
import { Observable, filter, tap } from 'rxjs';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { SpinnerServiceService } from 'src/app/modules/shared/serviceSpinner/spinner-service.service';

@Component({
  selector: 'app-liste-appels',
  templateUrl: './liste-appels.component.html',
  styleUrls: ['./liste-appels.component.css'],
})
export class ListeAppelsComponent implements OnInit {
  appels: any[] = [];
  actuelDate!: any;
  submissions: any[] = [];
  user!: any;
  showSpinner = false;
  showSubmission: boolean = false;
  showHeaderOfTable: boolean = false;

  constructor(
    private authService: AuthService,
    private spinnerService: SpinnerServiceService
  ) {
    this.user = sessionStorage.getItem('user');
    //// //console.log(this.user);

    this.spinnerService.spinner$.subscribe((data: boolean) => {
      setTimeout(() => {
        this.showSpinner = data ? data : false;
      });
    });
  }

  ngOnInit(): void {
    this.spinnerService.showSpinner();
    this.actuelDate = new Date().getTime();

    const IufApplicant = JSON.parse(this.user).iuf;
    //// //console.log(IufApplicant);
    //Recuperation des soumissions de l'applicant via son iuf

    // this.authService
    //   .getMySubmissions(JSON.parse(this.user).iuf)
    //   .subscribe((Response) => {
    //     // //// //console.log(Response);
    //     this.submissions = Response;
    //     //// //console.log(this.submissions);
    //   });

    //Recuperation et filtre des appels pour ne prendre que ceux dont la date de cloture n'est pas passe!

    this.authService.getAllApplications().subscribe((response) => {
      response.filter((appel: any) => {
        if (new Date(appel.closeDate).getTime() > this.actuelDate) {
          this.appels.push(appel);
        }
      });

      this.spinnerService.hideSpinner();
      //// //console.log(this.appels);
      this.authService
        .getMySubmissions(JSON.parse(this.user).iuf)
        .subscribe((Response) => {
          //// //console.log('Les soumissions', Response);

          this.submissions = Response;
          this.showSubmission = this.submissions.length == 0;
          this.showHeaderOfTable = this.submissions.length != 0;
          //// //console.log(this.showSubmission, this.submissions.length);
          this.appels = response;

          this.submissions.forEach((submission) => {
            this.appels = this.appels.filter(
              (appel) =>
                new Date(appel.closeDate).getTime() > this.actuelDate &&
                appel.id != submission.application.id
            );
          });

          // for (let index = 0; index < this.submissions.length; index++) {
          //   response.filter((appel: any) => {
          //     //// //console.log(
          //       'appelid:',
          //       appel.id,
          //       'soumissionId:',
          //       this.submissions[index].application.id
          //     );
          //     if (
          //       new Date(appel.closeDate).getTime() > this.actuelDate &&
          //       appel.id != this.submissions[index].application.id
          //     ) {
          //       this.appels.push(appel);
          //       //// //console.log('Ici');
          //     }
          //   });
          // }
        });

      // //// //console.log(this.appels);
    });
  }
}
